// eslint-disable-next-line import/prefer-default-export
export const reactSelectStyle = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 0,
    border: state.isFocused ? '2px solid #d01818' : '1px solid #c1c1c1',
    outline: 'none',
    '&:hover': {
      border: state.isFocused ? '2px solid #d01818' : '1px solid #c1c1c1',
    },
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? '#d01818' : 'black',
    backgroundColor: state.isFocused ? '#f1f5fa' : 0,
    '&:active': {
      backgroundColor: state.isFocused ? '#d4e5f9' : 0,
    },
  }),
};
